module.exports = __webpack_public_path__ + "img/illustration-reset-password-dark.5bec3370.png";